import type * as React from 'react';
import { get } from '@Domain/Api';
import beneficiaryHomonymsSearched, {
	type BeneficiaryHomonymsSearchedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryHomonymsSearched';
import beneficiaryHomonymsSearchFailed, {
	type BeneficiaryHomonymsSearchFailedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryHomonymsSearchFailed';
import type SearchBeneficiaryHomonyms from '@Application/Beneficiaries/Beneficiaries/Queries/SearchBeneficiaryHomonyms';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = BeneficiaryHomonymsSearchedAction | BeneficiaryHomonymsSearchFailedAction;

// Raw shape of the list endpoint's response, trimmed to the single field this probe needs: only `id`,
// never a name or an address — the rest of a beneficiary search result is health-adjacent data this
// check has no use for.
type BeneficiaryHomonymsSearchResponse = {
	readonly totalRecords: number;
	readonly results: ReadonlyArray<{ readonly id: number }>;
};

export default (query: SearchBeneficiaryHomonyms) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const url = `${parameters.api.host}/api/accounts/${query.accountId}/beneficiaries?${query.toQueryString()}`;

			const response = await get<BeneficiaryHomonymsSearchResponse>(url);
			const beneficiaryIds = response.results.map((beneficiary) => beneficiary.id);

			const action = beneficiaryHomonymsSearched(
				{ totalRecords: response.totalRecords, beneficiaryIds },
				query.facilityId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryHomonymsSearchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
